import CareerPlansView from './CareerPlansView'
export default CareerPlansView
